<template>
  <Multiselect
    v-if="options.length !== 0"
    v-model="value"
    v-bind="$attrs"
    :options="options"
    :label="label"
    :required="false"
    :pills="true"
  />
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Option } from '~/components/inputs/Multiselect.vue'

export type Filter = {
  label: string
  code: string
  name: string
  apiAlias: string
  options: {
    id: string
    name: string
  }[]
}

const props = defineProps<{
  filter: Filter
}>()

const label = computed(() => props.filter.label)

const options = computed<Option[]>(() =>
  props.filter.options.map((entity) => {
    return {
      value: entity.id,
      label: getTranslatedProperty(entity, 'name'),
    }
  })
)

const value = defineModel<string[]>()
</script>
